export default class ReplacementCosts {
  constructor(obj) {
    if (obj.replacement_costs) {
      this.fips = obj.replacement_costs.fips;
      this.apn = obj.replacement_costs.apn;
      this.zip_code = obj.replacement_costs.zip_code;
      this.census_tract = obj.replacement_costs.census_tract;
      this.is_condo = obj.replacement_costs.is_condo;
      this.has_fireplace = obj.replacement_costs.has_fireplace;
      this.has_heating_and_cooling =
        obj.replacement_costs.has_heating_and_cooling;
      this.total_area_sq_ft = obj.replacement_costs.total_area_sq_ft;
      this.luxury = obj.replacement_costs.luxury;
      this.semi_luxury = obj.replacement_costs.semi_luxury;
      this.best_std = obj.replacement_costs.best_std;
      this.good_std = obj.replacement_costs.good_std;
      this.avg_std = obj.replacement_costs.avg_std;
      this.min_std = obj.replacement_costs.min_std;
      this.meta = obj.replacement_costs.meta;
    }
  }
}
